import React from "react";
import { Link } from "react-router-dom";
import "../styles/Dashboard.css";

const ADMIN_MODULES = [
  {
    title: "Manage Staff",
    description: "Add, edit, and manage staff details and permissions.",
    icon: "🧑‍💼",
    link: "/admin/manage-staff"
  },
  {
    title: "Manage Students",
    description: "View, add, and manage student admissions and accounts.",
    icon: "🎓",
    link: "/admin/manage-student"
  },
  {
    title: "Manage Fees",
    description: "Track all student fee records and payments batch-wise.",
    icon: "💳",
    link: "/admin/manage-fees"
  },
  {
    title: "Manage Income",
    description: "Add and manage various income types (tuition, donations, trustee funds, etc.).",
    icon: "🏦",
    link: "/admin/manage-income",
    openAdd: true
  },
  {
    title: "Manage Expense",
    description: "Add and manage college expense records and heads.",
    icon: "📉",
    link: "/admin/manage-expense"
  },
  {
    title: "Manage Salaries",
    description: "Process staff salaries, view history, generate slips.",
    icon: "🧑‍🏫",
    link: "/admin/manage-salary"
  },
  {
    title: "Income & Expense",
    description: "Manage and review college income and expenses.",
    icon: "💰",
    link: "/admin/income-expense"
  },
  {
    title: "Reports",
    description: "Generate, download, and analyze data reports.",
    icon: "📊",
    link: "/admin/reports"
  },
  {
    title: "Settings",
    description: "Change admin settings, manage users, update password.",
    icon: "⚙️",
    link: "/admin/settings"
  },
  {
    title: "Student Applications",
    description: "View all student application forms.",
    icon: "📄",
    link: "/admin/applications"
  }
];

export default function AdminDashboard() {
  return (
    <div className="dashboard-wrapper">
      <h2>Admin Dashboard</h2>
      <p>Welcome to the GNM College Admin Panel. Select a module to manage key administrative activities.</p>
      <div className="dashboard-grid">
        {ADMIN_MODULES.map((mod) => (
          <Link
            to={mod.link}
            state={mod.openAdd ? { openAdd: true } : undefined}
            className="dashboard-card"
            key={mod.title}
            aria-label={mod.title}
          >
            <div className="dashboard-card-icon" style={{fontSize: 48}}>{mod.icon}</div>
            <div className="dashboard-card-title">{mod.title}</div>
            <div className="dashboard-card-desc">{mod.description}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}